import React, { useEffect } from 'react';
import WOW from 'wow.js';
import 'animate.css/animate.css';

const Intro = () => {
    useEffect(() => {
        const wow = new WOW();
        wow.init();
      }, []);
  return (
   <div className="intro-section" id="introduction">
    <div className="intro-inner wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
        <div className="intro-headings">
        <h2 class="section-heading main-title">OUR SOLUTIONS</h2>
            <h1>Let Professional Developers  Amplify Your Digital Presence With  Tailored Website Development  Services</h1>
        </div>

        <div className="intro-text">
            <div className="intro-text-wrap">
        <p>Web Gurus Hub weaves digital dreams into reality, creating captivating online experiences that leave a lasting impression. Like master craftsmen of the digital realm, we intricately thread together cutting-edge technology and artistic finesse, bringing your vision to life with every pixel. Our expertise in frontend web development and ecommerce solutions, including Shopify and WordPress, enables businesses to flourish in the online marketplace.</p>
        <a className='button' href="#contactus">LET's GET STARTED</a>
        <div className="developer"></div>
        </div>
        </div>
    </div>
   </div>
  )
}

export default Intro